import { combineReducers } from 'redux';
import { openedModals } from './opened-modals';
import { resolvedModalList } from './resolved-modal-list';

export const modal = combineReducers({ openedModals, resolvedModalList });
